/*
 * TeacherFilter Messages
 *
 * This contains all the text for the TeacherFilter component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultOptionTeacherLastName: {
        id: 'teacher-roll.container.teacherRoll.defaultOptionTeacherLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionTeacherClass: {
        id: 'teacher-roll.container.teacherRoll.defaultOptionTeacherClass',
        defaultMessage: 'All classes'
    },
    UnassignedTeacher: {
        id: 'teacher-roll.container.teacherRoll.UnassignedTeacher',
        defaultMessage: 'Unassigned teachers'
    },
    classroomList: {
        id: 'teacher-roll.container.teacherRoll.classroomList',
        defaultMessage: 'Select a {0} class'
    },
    errorOnDeletingAssignedTeachers: {
        id: 'teacher-roll.container.teacherRoll.errorOnDeletingAssignedTeachers',
        defaultMessage: 'Error - some selected teachers are assigned to classes'
    },
    deleteTeacherSuccessMessage: {
        id: 'teacher-roll.container.teacherRoll.deleteTeacherSuccessMessage',
        defaultMessage: '{count} teachers removed from the school roll'
    },
    deleteTeacherWarningMessage: {
        id: 'teacher-roll.container.teacherRoll.deleteTeacherWarningMessage',
        defaultMessage: 'Error - some selected teachers are assigned to classes and will not be deleted. {count} teachers have been removed from the school roll'
    }
});



// WEBPACK FOOTER //
// ./app/containers/teacher-roll/messages.js